import React from "react";
import AboutPremium from "../sections/AboutPremium";

const AboutPage = () => {
  return (
    <main>
      <AboutPremium />
    </main>
  );
};

export default AboutPage;
